/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListVsBuyoutBlock } from "./ListVsBuyoutBlock";

export const leadDetailConditionEnum = {
    excellent: "excellent",
    very_good: "very_good",
    good: "good",
    fair: "fair",
    poor: "poor",
    unknown: "unknown"
} as const;

export type LeadDetailConditionEnumKey = (typeof leadDetailConditionEnum)[keyof typeof leadDetailConditionEnum];

export const leadDetailPayoffVerificationStatusEnum = {
    verified: "verified",
    verified_by_sales_rep: "verified_by_sales_rep",
    customer_provided: "customer_provided",
    edited: "edited",
    sales_tax_review_needed: "sales_tax_review_needed"
} as const;

export type LeadDetailPayoffVerificationStatusEnumKey = (typeof leadDetailPayoffVerificationStatusEnum)[keyof typeof leadDetailPayoffVerificationStatusEnum];

export const leadDetailStatusEnum = {
    new: "new",
    ready_to_list: "ready_to_list",
    active: "active",
    accepted: "accepted",
    confirmed: "confirmed",
    contracts_sent: "contracts_sent",
    awaiting_pickup: "awaiting_pickup",
    picked_up: "picked_up",
    billed: "billed",
    sold: "sold",
    fallen: "fallen",
    unavailable: "unavailable",
    unresponsive: "unresponsive",
    expired: "expired"
} as const;

export type LeadDetailStatusEnumKey = (typeof leadDetailStatusEnum)[keyof typeof leadDetailStatusEnum];

export const leadDetailViewerOfferStateEnum = {
    pending: "pending",
    lost: "lost"
} as const;

export type LeadDetailViewerOfferStateEnumKey = (typeof leadDetailViewerOfferStateEnum)[keyof typeof leadDetailViewerOfferStateEnum];

export const offersStatusEnum2 = {
    pending: "pending",
    accepted: "accepted",
    rejected: "rejected",
    countered: "countered",
    expired: "expired",
    withdrawn: "withdrawn",
    outbid: "outbid",
    superseded: "superseded",
    edited: "edited"
} as const;

export type OffersStatusEnum2Key = (typeof offersStatusEnum2)[keyof typeof offersStatusEnum2];

export const offersTypeEnum2 = {
    driver_ask: "driver_ask",
    dealer_offer: "dealer_offer",
    driver_counter: "driver_counter",
    dealer_counter: "dealer_counter"
} as const;

export type OffersTypeEnum2Key = (typeof offersTypeEnum2)[keyof typeof offersTypeEnum2];

export const latestOfferStatusEnum2 = {
    pending: "pending",
    accepted: "accepted",
    rejected: "rejected",
    countered: "countered",
    expired: "expired",
    withdrawn: "withdrawn",
    outbid: "outbid",
    superseded: "superseded",
    edited: "edited"
} as const;

export type LatestOfferStatusEnum2Key = (typeof latestOfferStatusEnum2)[keyof typeof latestOfferStatusEnum2];

export const latestOfferTypeEnum2 = {
    driver_ask: "driver_ask",
    dealer_offer: "dealer_offer",
    driver_counter: "driver_counter",
    dealer_counter: "dealer_counter"
} as const;

export type LatestOfferTypeEnum2Key = (typeof latestOfferTypeEnum2)[keyof typeof latestOfferTypeEnum2];

export const acceptedOfferStatusEnum2 = {
    pending: "pending",
    accepted: "accepted",
    rejected: "rejected",
    countered: "countered",
    expired: "expired",
    withdrawn: "withdrawn",
    outbid: "outbid",
    superseded: "superseded",
    edited: "edited"
} as const;

export type AcceptedOfferStatusEnum2Key = (typeof acceptedOfferStatusEnum2)[keyof typeof acceptedOfferStatusEnum2];

export const acceptedOfferTypeEnum2 = {
    driver_ask: "driver_ask",
    dealer_offer: "dealer_offer",
    driver_counter: "driver_counter",
    dealer_counter: "dealer_counter"
} as const;

export type AcceptedOfferTypeEnum2Key = (typeof acceptedOfferTypeEnum2)[keyof typeof acceptedOfferTypeEnum2];

export const signingStatusEnum = {
    none: "none",
    pending: "pending",
    partial: "partial",
    completed: "completed"
} as const;

export type SigningStatusEnumKey = (typeof signingStatusEnum)[keyof typeof signingStatusEnum];

export const signersStateEnum = {
    signed: "signed",
    awaiting: "awaiting",
    pending: "pending"
} as const;

export type SignersStateEnumKey = (typeof signersStateEnum)[keyof typeof signersStateEnum];

export const leadDetailSourceEnum = {
    leaseend: "leaseend"
} as const;

export type LeadDetailSourceEnumKey = (typeof leadDetailSourceEnum)[keyof typeof leadDetailSourceEnum];

export const leadDetailGateDecisionEnum = {
    list_anyway: "list_anyway",
    buyout: "buyout",
    finish_lease: "finish_lease"
} as const;

export type LeadDetailGateDecisionEnumKey = (typeof leadDetailGateDecisionEnum)[keyof typeof leadDetailGateDecisionEnum];

export type LeadDetail = {
    /**
     * @type string, uuid
    */
    id: string;
    /**
     * @type string
    */
    vin: string;
    /**
     * @type number
    */
    year: number;
    /**
     * @type string
    */
    make: string;
    /**
     * @type string
    */
    model: string;
    /**
     * @type string
    */
    trim: string;
    /**
     * @type string
    */
    color: string | null;
    /**
     * @type string
    */
    condition: LeadDetailConditionEnumKey;
    /**
     * @type number
    */
    mileage: number | null;
    /**
     * @type number
    */
    payoff: number | null;
    /**
     * @type string, date
    */
    goodThroughDate?: string | null;
    /**
     * @type string, date-time
    */
    payoffVerifiedAt?: string | null;
    /**
     * @type string
    */
    payoffVerificationStatus?: LeadDetailPayoffVerificationStatusEnumKey | null;
    /**
     * @type boolean
    */
    payoffVerified: boolean;
    /**
     * @type string
    */
    lienholder: string;
    /**
     * @type string
    */
    city: string | null;
    /**
     * @type string
    */
    state: string | null;
    /**
     * @type string
    */
    zip: string | null;
    /**
     * @type boolean
    */
    lookingToBuy: boolean | null;
    /**
     * @type string
    */
    externalId?: string | null;
    /**
     * @type string
    */
    status: LeadDetailStatusEnumKey;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @type string, date-time
    */
    activatedAt?: string | null;
    /**
     * @type string, date-time
    */
    acceptedAt: string | null;
    /**
     * @type string
    */
    fuelType: string | null;
    /**
     * @type string
    */
    vehicleType: string | null;
    /**
     * @type number
    */
    retailBookValue: number | null;
    /**
     * @type number
    */
    lendingBookValue: number | null;
    /**
     * @type string, date-time
    */
    kbbValuationDate: string | null;
    /**
     * @type array
    */
    kbbSelectedOptions: {
        /**
         * @type string
        */
        id: string;
        /**
         * @type string
        */
        name: string;
        /**
         * @type string
        */
        type: string;
        /**
         * @type boolean
        */
        removed: boolean;
        /**
         * @type number
        */
        retailOptionPrice: number | null;
        /**
         * @type number
        */
        lendingOptionPrice: number | null;
    }[] | null;
    /**
     * @type number
    */
    equity: number | null;
    /**
     * @type number
    */
    driverAsk: number | null;
    /**
     * @type number
    */
    latitude: number | null;
    /**
     * @type number
    */
    longitude: number | null;
    /**
     * @type string, uuid
    */
    claimedById: string | null;
    /**
     * @type string, date-time
    */
    claimedAt: string | null;
    /**
     * @type string
    */
    claimedByName: string | null;
    /**
     * @type number
    */
    orgOfferCount?: number | null;
    /**
     * @type string
    */
    viewerOfferState?: LeadDetailViewerOfferStateEnumKey | null;
    /**
     * @type array | undefined
    */
    offers?: {
        /**
         * @type string
        */
        id: string;
        /**
         * @type number
        */
        amount: number;
        /**
         * @type string
        */
        status: OffersStatusEnum2Key;
        /**
         * @type string
        */
        type: OffersTypeEnum2Key;
        /**
         * @type string
        */
        createdAt: string;
        /**
         * @type string
        */
        notes: string | null;
        /**
         * @type string
        */
        notifiedAt: string | null;
        /**
         * @type string
        */
        userName: string | null;
        /**
         * @type string
        */
        expiresAt?: string | null;
    }[];
    /**
     * @type object
    */
    latestOffer?: {
        /**
         * @type string
        */
        id: string;
        /**
         * @type number
        */
        amount: number;
        /**
         * @type string
        */
        status: LatestOfferStatusEnum2Key;
        /**
         * @type string
        */
        type: LatestOfferTypeEnum2Key;
        /**
         * @type string
        */
        createdAt: string;
        /**
         * @type string
        */
        notes: string | null;
        /**
         * @type string
        */
        notifiedAt: string | null;
        /**
         * @type string
        */
        userName: string | null;
        /**
         * @type string
        */
        expiresAt?: string | null;
    } | null;
    /**
     * @type object
    */
    acceptedOffer?: {
        /**
         * @type string
        */
        id: string;
        /**
         * @type number
        */
        amount: number;
        /**
         * @type string
        */
        status: AcceptedOfferStatusEnum2Key;
        /**
         * @type string
        */
        type: AcceptedOfferTypeEnum2Key;
        /**
         * @type string
        */
        createdAt: string;
        /**
         * @type string
        */
        notes: string | null;
        /**
         * @type string
        */
        notifiedAt: string | null;
        /**
         * @type string
        */
        userName: string | null;
        /**
         * @type string
        */
        expiresAt?: string | null;
    } | null;
    /**
     * @type string
    */
    acceptedOrgName?: string | null;
    /**
     * @type number
    */
    fee: number | null;
    /**
     * @type object
    */
    checklistProgress?: {
        /**
         * @type integer
        */
        done: number;
        /**
         * @type integer
        */
        total: number;
        /**
         * @type boolean
        */
        complete: boolean;
    } | null;
    /**
     * @type string, uuid
    */
    feeOverriddenById: string | null;
    /**
     * @type string, date-time
    */
    feeOverriddenAt: string | null;
    /**
     * @type number
    */
    offerCount?: number | null;
    /**
     * @type boolean
    */
    hasAcceptedOffer: boolean;
    /**
     * @type object
    */
    contactInfo?: {
        /**
         * @type string
        */
        name: string | null;
        /**
         * @type string
        */
        email: string | null;
        /**
         * @type string
        */
        phone: string | null;
    } | null;
    /**
     * @type string
    */
    name: string | null;
    /**
     * @type string
    */
    email: string | null;
    /**
     * @type string
    */
    phone: string | null;
    /**
     * @type string
    */
    addressLine1: string | null;
    /**
     * @type string
    */
    addressLine2: string | null;
    /**
     * @type boolean
    */
    wonByAnotherDealer: boolean;
    /**
     * @type array
    */
    conditionReport?: {
        /**
         * @type string
        */
        questionId: string;
        value: (boolean | string | number);
        /**
         * @type string
        */
        photoId: string | null;
        /**
         * @type string
        */
        answeredAt: string;
    }[] | null;
    /**
     * @type string
    */
    sellTimeline?: string | null;
    /**
     * @type boolean | undefined
    */
    conditionReportEnabled?: boolean;
    /**
     * @type object | undefined
    */
    signing?: {
        /**
         * @type boolean
        */
        canSendForSigning: boolean;
        /**
         * @type boolean
        */
        reachedSigning: boolean;
        /**
         * @type boolean
        */
        signedDocumentAvailable: boolean;
        /**
         * @type string
        */
        status: SigningStatusEnumKey;
        /**
         * @type object | undefined
        */
        nextSigner?: {
            /**
             * @type string
            */
            role: string;
            /**
             * @type string
            */
            email: string;
        };
        /**
         * @type array | undefined
        */
        signers?: {
            /**
             * @type number
            */
            id: number;
            /**
             * @type string
            */
            role: string;
            /**
             * @type string
            */
            email: string;
            /**
             * @type string
            */
            state: SignersStateEnumKey;
            /**
             * @type string
            */
            signedAt: string | null;
        }[];
        /**
         * @type number | undefined
        */
        submissionId?: number;
    };
    /**
     * @type string, date-time
    */
    lastActivityAt?: string | null;
    /**
     * @type string
    */
    source?: LeadDetailSourceEnumKey | null;
    /**
     * @type string
    */
    sourceChannel?: string | null;
    /**
     * @type object
    */
    driverEvents?: {
        /**
         * @type string | undefined, date-time
        */
        sold_reveal_seen?: string;
        /**
         * @type string | undefined, date-time
        */
        pickup_address_confirmed?: string;
    } | null;
    listVsBuyout?: ListVsBuyoutBlock | null;
    /**
     * @type object
    */
    listVsBuyoutInputs?: {
        /**
         * @maxLength 5000
         * @type number
        */
        monthlyPayment?: number | null;
        /**
         * @type string, date
        */
        leaseEndDate?: string | null;
        /**
         * @type number
        */
        residual?: number | null;
        /**
         * @minLength 5000
         * @maxLength 30000
         * @type integer
        */
        annualAllowance?: number | null;
        /**
         * @minLength 12
         * @maxLength 60
         * @type integer
        */
        originalTermMonths?: number | null;
        /**
         * @minLength 0
         * @maxLength 10000
         * @type integer
        */
        projectedMilesOverride?: number | null;
        /**
         * @type string | undefined, date-time
        */
        updatedAt?: string;
    } | null;
    /**
     * @type string
    */
    gateDecision?: LeadDetailGateDecisionEnumKey | null;
    /**
     * @type string, date-time
    */
    gateDecidedAt?: string | null;
    /**
     * @type string, date
    */
    leaseMaturityDate?: string | null;
    /**
     * @type number
    */
    leaseMonthlyPayment?: number | null;
    /**
     * @type integer
    */
    leaseRemainingPayments?: number | null;
};